import { useMemo } from 'react'
import { useGroup } from '@wellesley/group'
import { Group } from '@wellesley/openapi'
import { selectUploadFile } from '@wellesley/uploads'

type UseContextChipProps = {
  groupName: string | undefined
  showContextChip: boolean
  inThisContext: boolean
  onClose: () => void
}

const getType = (groupName: string | undefined) => {
  return groupName ? 'group' : ''
}

const getContextChipText = (inThisContext: boolean, itemName?: string) => {
  return inThisContext ? 'Only this group' : itemName || ''
}

const getContextChipAvatarSrc = (group?: Group | null) => {
  return (
    selectUploadFile({
      size: 24,
      upload: group?.avatar,
    })?.uri || ''
  )
}

export const useContextChip = ({
  groupName,
  showContextChip,
  inThisContext,
  onClose,
}: UseContextChipProps) => {
  const { group } = useGroup({ groupname: groupName || '' })

  const contextChip = useMemo(() => {
    if (!groupName) return null

    const type = getType(groupName)
    if (!type) return []

    const chip = {
      text: getContextChipText(inThisContext, groupName),
      show: showContextChip,
      avatarSrc: getContextChipAvatarSrc(group),
      onClose,
    }

    return chip.show && chip.text ? [chip] : []
  }, [groupName, group, showContextChip, onClose, inThisContext])

  return { contextChip }
}
